import { apiService } from '../../..'
import { AmountDueSummaryResponse } from '../types'

export const amountDueSummaryService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getAmountDueSummary: build.query<AmountDueSummaryResponse, void>({
      query: () => {
        return {
          url: 'portal/consumers/amount-due-summary',
          method: 'get',
        }
      },
      providesTags: ['AmountDueSummary'],
    }),
  }),
})
